Monitoring.Views ||= {}

class Monitoring.Views.MovistarRulesView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_rules"]

  events :
    'click #deactivate-all': 'onClickDeactivateAll'

  initialize: (@options = {}) ->
    @rules             = @options.rules
    @availableTags     = @options.available_tags
    @availableSubtypes = @options.available_subtypes
    @currentUser       = @options.current_user
    @accountId         = @options.account_id

  render: =>
    @listView.remove() if @listView
    @activeCount = @activeRulesCount()
    @$el.html(@template(@))
    @renderList()
    @

  getStatusString: ->
    "Estado de reglas: #{@rulesStatusString()}"

  rulesStatusString: ->
    if @activeCount == 0
      "Sin reglas activas"
    else
      suffix = if @activeCount > 1 then 's' else ''
      "#{@activeCount} regla#{suffix} activa#{suffix}"

  activeRulesCount: ->
    @activeRules().length

  activeRules: ->
    _.filter(@rules.models, (rule) -> rule.get('active'))

  renderList: =>
    @listView.remove() if @listView
    @listView = new Monitoring.Views.MovistarRuleListView({
      rules: @rules
      availableTags: @availableTags
      availableSubtypes: @availableSubtypes
      currentUser: @currentUser,
      accountId: @accountId
    })
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'rule:activated', @afterActivatingRule)
    @listenTo(@listView, 'rule:deactivated', @afterDeactivatingRule)

  afterActivatingRule: ->
    @activeCount = @activeCount + 1
    @updateRuleStatusString()

  afterDeactivatingRule: ->
    @activeCount = @activeCount - 1
    @updateRuleStatusString()

  updateRuleStatusString: ->
    @$el.find('#status-container').html(@getStatusString())

  onClickDeactivateAll: (evt) ->
    swal({
      title: I18n.t('monitoring.rules.confirmation.are_you_sure')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.rules.confirmation.confirm_deactivate_all')
      cancelButtonText: I18n.t('monitoring.rules.confirmation.cancel')
      closeOnConfirm: true
    }, =>
      _.each(@activeRules(), (rule) =>
        @listView.updateActiveStatus(rule, false)
      )
      @render()
    )
